var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDownloadIconinline = function SvgDownloadIconinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.24609 14.3945H10.9632",
    stroke: "white",
    strokeWidth: 1.47183,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84041 1.22949C6.84041 0.823058 6.51093 0.493577 6.10449 0.493577C5.69806 0.493577 5.36858 0.823058 5.36858 1.22949L6.84041 1.22949ZM5.58412 11.0858C5.87151 11.3732 6.33747 11.3732 6.62486 11.0858L11.3082 6.40247C11.5956 6.11507 11.5956 5.64912 11.3082 5.36173C11.0208 5.07433 10.5548 5.07433 10.2675 5.36173L6.10449 9.52469L1.94153 5.36173C1.65414 5.07433 1.18818 5.07433 0.900788 5.36173C0.613396 5.64912 0.613396 6.11507 0.900788 6.40247L5.58412 11.0858ZM5.36858 1.22949L5.36858 10.5654L6.84041 10.5654L6.84041 1.22949L5.36858 1.22949Z",
    fill: "white"
  })));
};
export default SvgDownloadIconinline;